import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from '../../../../../util/reactIntl';
import { setSelectedCurrency } from '../../../../../ducks/currency.duck';
import {
  Menu,
  MenuLabel,
  MenuContent,
  MenuItem,
} from '../../../../../components';

import css from './CurrencyMenu.module.css';

const CurrencyMenu = ({ currentPage }) => {
  const dispatch = useDispatch();
  const currentCurrency = useSelector(state => state.currency.selectedCurrency);
  const [isOpen, setIsOpen] = useState(false);

  const handleCurrencyChange = (currency) => {
    setIsOpen(false);
    dispatch(setSelectedCurrency(currency));
  };

  return (
    <Menu isOpen={isOpen} onToggleActive={setIsOpen}>
      <MenuLabel className={css.currencyMenuLabel} isOpenClassName={css.currencyMenuIsOpen}>
        <div className={css.currencySelector}>
          <span>{currentCurrency}</span>
        </div>
      </MenuLabel>
      <MenuContent className={css.currencyMenuContent}>
        <MenuItem key="AED">
          <button 
            className={css.currencyOption}
            onClick={() => handleCurrencyChange('AED')}
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="CurrencyMenu.aed" />
          </button>
        </MenuItem>
        <MenuItem key="USD">
          <button 
            className={css.currencyOption}
            onClick={() => handleCurrencyChange('USD')}
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="CurrencyMenu.usd" />
          </button>
        </MenuItem>
        <MenuItem key="EUR">
          <button 
            className={css.currencyOption}
            onClick={() => handleCurrencyChange('EUR')}
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="CurrencyMenu.eur" />
          </button>
        </MenuItem>
      </MenuContent>
    </Menu>
  );
};

export default CurrencyMenu;
